// ── CSV export helpers (client-side, no dependencies) ───────────────────────────
// Used by buyer & seller order/account tables to download day/week/month records
// that open directly in Excel / Google Sheets.

function esc(v) {
  if (v == null) return '';
  const s = String(v);
  // Quote if the value contains a comma, quote, or newline.
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// rows: array of plain objects. columns: [{ key, label }]. Returns a CSV string.
export function toCSV(rows, columns) {
  const cols = columns || (rows[0] ? Object.keys(rows[0]).map(k => ({ key: k, label: k })) : []);
  const header = cols.map(c => esc(c.label)).join(',');
  const body = rows.map(r => cols.map(c => esc(typeof c.format === 'function' ? c.format(r[c.key], r) : r[c.key])).join(',')).join('\n');
  return header + '\n' + body;
}

// Trigger a browser download of the given CSV text.
export function downloadCSV(filename, csv) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Bucket key for an ISO date string at day / week / month granularity.
export function periodKey(dateStr, period) {
  const d = new Date(dateStr);
  if (isNaN(d)) return 'unknown';
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  if (period === 'month') return `${y}-${m}`;
  if (period === 'week') {
    // ISO-ish week: Thursday-anchored week number.
    const tmp = new Date(Date.UTC(y, d.getUTCMonth(), d.getUTCDate()));
    const dayNum = (tmp.getUTCDay() + 6) % 7;
    tmp.setUTCDate(tmp.getUTCDate() - dayNum + 3);
    const firstThursday = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 4));
    const week = 1 + Math.round(((tmp - firstThursday) / 86400000 - 3 + ((firstThursday.getUTCDay() + 6) % 7)) / 7);
    return `${tmp.getUTCFullYear()}-W${String(week).padStart(2, '0')}`;
  }
  // day
  return `${y}-${m}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

// Group rows by period and aggregate order totals — used for the summary CSV.
export function groupByPeriod(orders, period) {
  const buckets = {};
  for (const o of orders) {
    const key = periodKey(o.createdAt, period);
    if (!buckets[key]) buckets[key] = { period: key, orders: 0, totalCoins: 0, totalAmount: 0 };
    buckets[key].orders += 1;
    buckets[key].totalCoins += o.totalCoins || 0;
    buckets[key].totalAmount += o.totalAmount || 0;
  }
  return Object.values(buckets).sort((a, b) => (a.period < b.period ? 1 : -1));
}
